module.exports = __webpack_public_path__ + "img/op_img-header.17f770b.png";